export default class DefaultCondition {

    test() {
        return true
    }
}